import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { LandingHeader } from '@/components/landing/LandingHeader';
import { HeroSection } from '@/components/landing/HeroSection';
import { FeaturesSection } from '@/components/landing/FeaturesSection';
import { HowItWorksSection } from '@/components/landing/HowItWorksSection';
import { PricingSection } from '@/components/landing/PricingSection';
import { MetricsSection } from '@/components/landing/MetricsSection';
import { IntegrationsSection } from '@/components/landing/IntegrationsSection';
import { FAQSection } from '@/components/landing/FAQSection';
import { CTASection } from '@/components/landing/CTASection';
import { ContactSection } from '@/components/landing/ContactSection';
import { LandingFooter } from '@/components/landing/LandingFooter';
import { ScrollToTopButton } from '@/components/landing/ScrollToTopButton';

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      // Pequeno delay para garantir que o DOM carregou
      setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Garantir que inicia no topo quando não há scrollTo
      window.scrollTo(0, 0);
    }
  }, [location]);
  return (
    <div className="min-h-screen bg-background">
      <LandingHeader />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <PricingSection />
        <MetricsSection />
        <IntegrationsSection />
        <FAQSection />
        <CTASection />
        <ContactSection />
      </main>
      <LandingFooter />
      <ScrollToTopButton />
    </div>
  );
}
